import React, { Component } from 'react';
import SectionBlock from './../../../../SectionBlock/SectionBlock';
import SmallScoreBarSection from './../../../../SmallScoreBarSection/SmallScoreBarSection';
import ScoreRange from './../../../../../constants/ScoreRange';
import ScoreBarTypes from './../../../../../constants/ScoreBarTypes';
import style from './style/abilitytochange.scss';

export default class AbilityToChangeAttachment extends Component {
    constructor(props) {
        super(props);

        this.getScoreBlockContent = this.getScoreBlockContent.bind(this);
    }

    getScoreBlockContent(handle) {
        let getScoreBlockContent = null;

        if (!this.props.content || !this.props.content.scores) {
            return null;
        }

        this.props.content.scores.some(scoreBlock => {
            if (scoreBlock.handle === handle) {
                getScoreBlockContent = scoreBlock;
            }

            return getScoreBlockContent;
        });

        return getScoreBlockContent;
    }

    render() {
        const { content, i18nParticipation } = this.props;

        let textForIcon = '';
        let basedOnAbilityToChange = '';
        let basedOn = '';

        if (content.score) {
            basedOn = content.consultant ? content.consultant : i18nParticipation.report_consultant.toLowerCase()

            basedOnAbilityToChange = <p>{ i18nParticipation.report_by } { basedOn }</p>;
        }

        let iconDefinition = '';

        if (content.score) {
            iconDefinition = 'user-edit';
        } else if (content.score) {
            iconDefinition = 'desktop';
        }

        let score = '';

        if (content.score) {
            score = content.score;
        }

        return <div className={ `${style.report_page_container} ${style.abilityToChange}` }>

            { content.definition
                ? <SectionBlock classes={{ root: style.sectionBlockBlue }}>
                    <p dangerouslySetInnerHTML={{ __html: content.introduction }}/>
                </SectionBlock>
                : null
            }

            <SectionBlock>
                <section className={ style.mainScoreBlockSection }>
                    <ul>
                        <li>
                            <SmallScoreBarSection
                                title={ i18nParticipation.report_power_to_change }
                                scoreMin={ ScoreRange.ABILITY_TO_CHANGE.MIN }
                                scoreMax={ ScoreRange.ABILITY_TO_CHANGE.MAX }
                                scoreValue={ score }
                                iconText={ basedOnAbilityToChange }
                                scoreLevelDescription={ content.evaluation }
                                iconType={ iconDefinition }
                                classes={{
                                    root: style.mainScoreBlockSection__smallScoreBarSection,
                                    fill: style.fill,
                                    blank: style.blank,
                                    roundIcon: {
                                        roundIconFigureWrapper: style.abilityToChange__roundIconFigureWrapper
                                    }
                                }}
                                autoScaleWidth={ true }
                                scoreBarType={ ScoreBarTypes.NORMAL }
                            />
                        </li>
                        <li>
                            <aside>
                                <p dangerouslySetInnerHTML={{ __html: content.definition }} />
                            </aside>
                        </li>
                    </ul>
                </section>
            </SectionBlock>

            <SectionBlock>
                <section className={ style.groupedScoreBlockSection }>
                    <ul>
                        { this.getScoreBlockContent('growthMindset') && this.getScoreBlockContent('growthMindset').score
                            ? <li>
                                <SmallScoreBarSection
                                    title={ i18nParticipation.report_growth_mindset }
                                    scoreMin={ ScoreRange.ABILITY_TO_CHANGE.MIN }
                                    scoreMax={ ScoreRange.ABILITY_TO_CHANGE.MAX }
                                    scoreValue={ this.getScoreBlockContent('growthMindset').score }
                                    iconText={ <p>{ this.getScoreBlockContent('growthMindset').basedOn }</p> }
                                    scoreLevelDescription={ this.getScoreBlockContent('growthMindset').evaluation }
                                    iconType={ 'user-edit' }
                                    classes={{
                                        root: style.groupedScoreBlockSection__smallScoreBarSection,
                                        fill: style.fill,
                                        blank: style.blank,
                                        roundIcon: {
                                            roundIconFigureWrapper: style.abilityToChange__roundIconFigureWrapper
                                        }
                                    }}
                                    scoreBarType={ ScoreBarTypes.NORMAL }
                                >
                                    <p className={ style.abilityToChange__smallScoreBarSectionDescription }>
                                        { i18nParticipation.report_growth_mindset_text }
                                    </p>
                                </SmallScoreBarSection>
                            </li>
                            : null }
                        { this.getScoreBlockContent('energy') && this.getScoreBlockContent('energy').score
                            ? <li>
                                <SmallScoreBarSection
                                    title={ i18nParticipation.report_energy }
                                    scoreMin={ ScoreRange.ABILITY_TO_CHANGE.MIN }
                                    scoreMax={ ScoreRange.ABILITY_TO_CHANGE.MAX }
                                    scoreValue={ this.getScoreBlockContent('energy').score }
                                    iconText={ <p>{ this.getScoreBlockContent('energy').basedOn }</p> }
                                    scoreLevelDescription={ this.getScoreBlockContent('energy').evaluation }
                                    iconType={ 'user-edit' }
                                    classes={{
                                        root: style.groupedScoreBlockSection__smallScoreBarSection,
                                        fill: style.fill,
                                        blank: style.blank,
                                        roundIcon: {
                                            roundIconFigureWrapper: style.abilityToChange__roundIconFigureWrapper
                                        }
                                    }}
                                    scoreBarType={ ScoreBarTypes.NORMAL }
                                >
                                    <p className={ style.abilityToChange__smallScoreBarSectionDescription }>
                                        { i18nParticipation.report_energy_text }
                                    </p>
                                </SmallScoreBarSection>
                            </li>
                            : null }
                        { this.getScoreBlockContent('selfManagement') && this.getScoreBlockContent('selfManagement').score
                            ? <li>
                                <SmallScoreBarSection
                                    title={ i18nParticipation.report_self_management }
                                    scoreMin={ ScoreRange.ABILITY_TO_CHANGE.MIN }
                                    scoreMax={ ScoreRange.ABILITY_TO_CHANGE.MAX }
                                    scoreValue={ this.getScoreBlockContent('selfManagement').score }
                                    iconText={ <p>{ this.getScoreBlockContent('selfManagement').basedOn }</p> }
                                    scoreLevelDescription={ this.getScoreBlockContent('selfManagement').evaluation }
                                    iconType={ 'user-edit' }
                                    classes={{
                                        root: style.groupedScoreBlockSection__smallScoreBarSection,
                                        fill: style.fill,
                                        blank: style.blank,
                                        roundIcon: {
                                            roundIconFigureWrapper: style.abilityToChange__roundIconFigureWrapper
                                        }
                                    }}
                                    scoreBarType={ ScoreBarTypes.NORMAL }
                                >
                                    <p className={ style.abilityToChange__smallScoreBarSectionDescription }>
                                        { i18nParticipation.report_self_management_text }
                                    </p>
                                </SmallScoreBarSection>
                            </li>
                            : null }
                        { this.getScoreBlockContent('agility') && this.getScoreBlockContent('agility').score
                            ? <li>
                                <SmallScoreBarSection
                                    title={ i18nParticipation.report_agility }
                                    scoreMin={ ScoreRange.ABILITY_TO_CHANGE.MIN }
                                    scoreMax={ ScoreRange.ABILITY_TO_CHANGE.MAX }
                                    scoreValue={ this.getScoreBlockContent('agility').score }
                                    iconText={ <p>{ this.getScoreBlockContent('agility').basedOn }</p> }
                                    scoreLevelDescription={ this.getScoreBlockContent('agility').evaluation }
                                    iconType={ 'user-edit' }
                                    classes={{
                                        root: style.groupedScoreBlockSection__smallScoreBarSection,
                                        fill: style.fill,
                                        blank: style.blank,
                                        roundIcon: {
                                            roundIconFigureWrapper: style.abilityToChange__roundIconFigureWrapper
                                        }
                                    }}
                                    scoreBarType={ ScoreBarTypes.NORMAL }
                                >
                                    <p className={ style.abilityToChange__smallScoreBarSectionDescription }>
                                        { i18nParticipation.report_agility_text }
                                    </p>
                                </SmallScoreBarSection>
                            </li>
                            : null }
                    </ul>
                </section>
            </SectionBlock>

        </div>;
    }
}
